import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { ProductComparisonProductCodeRequestDTO } from "./dto";

const apiUrl = occUrl("/product-comparison/addProduct");

export function sendData(data: string) {
  return occFetch(apiUrl, {
    body: JSON.stringify({ productCode: data } satisfies ProductComparisonProductCodeRequestDTO),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  }).then((res) => res);
}
